module.exports = __webpack_public_path__ + "static/media/AccountSetting.1902103e.svg";